export const CREATOR_ACTION_KEYS = {
  ADD_TO_MY_CREATORS: 'add-to-my-creators',
  REMOVE_FROM_MY_CREATORS: 'remove-from-my-creators',
  ADD_TO_CAMPAIGN: 'add-to-campaign',
  SHARE_CREATOR: 'share-creator',
  INVITE_CREATOR: 'invite-creator',
  MESSAGE_CREATOR: 'message-creator',
  CREATE_AND_SHARE_LIST: 'create-and-share-list',
  SEND_EMAIL: 'send-email',
  ADD_NOTE: 'add-note',
} as const;

export type CreatorActionKey =
  (typeof CREATOR_ACTION_KEYS)[keyof typeof CREATOR_ACTION_KEYS];
